import { Newlogo } from "../../components";
const PageNotFound = () => {
  return (
    <div className="bg-primary flex flex-col justify-center items-center h-screen text-white">
      <div className="flex justify-center items-center xs:mb-3 sm:mb-4 lg:mb-5">
        <Newlogo />
      </div>
      <h1 className="font-unboundedBold xs:text-4xl sm:text-6xl lg:text-8xl xs:mb-3 sm:mb-4 lg:mb-5">
        404
      </h1>
      <h2 className="font-onestRegular xs:text-xl sm:test-2xl lg:text-3xl">
        Page Not Found
      </h2>
    </div>
  );
};
export default PageNotFound;
